import styled from 'styled-components';
import { font } from '../../../Players/SortImagesActivity/sortImages.utils';
import { Modal } from 'antd';

export const StyledSortImagesExtendedDescription = styled(Modal)`
  width: 90%;
  height: 90%;

  .ant-modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .ant-modal-body {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin-top: 20px;
      overflow-y: auto;

      .questions {
        flex: 1;
        font-family: ${font.family};
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin-bottom: 20px;
      }
    }
  }
`;
